import Data from './settings.json';
// $FlowFixMe
const localTextJsons = require.context('./', false, /\.json$/);

let searchOptions = window.searchParameters;
if (searchOptions == null) {
  searchOptions = {};
}

let build = process.env.REACT_APP_BUILD ?? (Data.builds[0]);
if (searchOptions.build != null) {
  build = searchOptions.build;
}
console.log("build:", build);

const BuildType = {
  build: build
}

const SettingsData = Object.assign(BuildType, ...Object.keys(Data).map((key) => {
  const buildPrefix = `${BuildType.build}_`;
  if (key.includes(buildPrefix)) {
    return {[key.substring(buildPrefix.length, key.length)]:Data[key]}
  }
  else if (key === 'builds') {
    return null;
  }
  else if (!key.includes('_')) {
    return {[key]:Data[key]}
  }
  return null;
}));

console.assert(SettingsData.lang !== undefined);
console.log("SettingsData.lang:", SettingsData.lang);

const Settings = Object.assign(SettingsData, {
  localKey: Array.isArray(SettingsData.lang) ? SettingsData.lang[SettingsData.lang.length - 1] : SettingsData.lang,
  localTexts: Array.isArray(SettingsData.lang) ? SettingsData.lang?.map(value => localTextJsons(`./${value}.json`)) : [localTextJsons(`./${SettingsData.lang}.json`)],
});

export default Settings;